// US State ISO 3166-2 codes mapping
export const US_STATES = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AS', name: 'American Samoa' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'DC', name: 'District of Columbia' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'GU', name: 'Guam' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'PR', name: 'Puerto Rico' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VI', name: 'Virgin Islands' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' },
];

export const PUERTO_RICO_STATES = [{ code: 'PR', name: 'Puerto Rico' }];

// Canadian Provinces and Territories
export const CANADA_STATES = [
  { code: 'AB', name: 'Alberta' },
  { code: 'BC', name: 'British Columbia' },
  { code: 'MB', name: 'Manitoba' },
  { code: 'NB', name: 'New Brunswick' },
  { code: 'NL', name: 'Newfoundland and Labrador' },
  { code: 'NT', name: 'Northwest Territories' },
  { code: 'NS', name: 'Nova Scotia' },
  { code: 'NU', name: 'Nunavut' },
  { code: 'ON', name: 'Ontario' },
  { code: 'PE', name: 'Prince Edward Island' },
  { code: 'QC', name: 'Quebec' },
  { code: 'SK', name: 'Saskatchewan' },
  { code: 'YT', name: 'Yukon' },
];

// Ecuador Provinces
export const ECUADOR_STATES = [
  { code: 'A', name: 'Azuay' },
  { code: 'B', name: 'Bolívar' },
  { code: 'C', name: 'Carchi' },
  { code: 'F', name: 'Cañar' },
  { code: 'H', name: 'Chimborazo' },
  { code: 'X', name: 'Cotopaxi' },
  { code: 'O', name: 'El Oro' },
  { code: 'E', name: 'Esmeraldas' },
  { code: 'W', name: 'Galápagos' },
  { code: 'G', name: 'Guayas' },
  { code: 'I', name: 'Imbabura' },
  { code: 'L', name: 'Loja' },
  { code: 'R', name: 'Los Ríos' },
  { code: 'M', name: 'Manabí' },
  { code: 'S', name: 'Morona-Santiago' },
  { code: 'N', name: 'Napo' },
  { code: 'D', name: 'Orellana' },
  { code: 'Y', name: 'Pastaza' },
  { code: 'P', name: 'Pichincha' },
  { code: 'SE', name: 'Santa Elena' },
  { code: 'SDT', name: 'Santo Domingo de los Tsáchilas' },
  { code: 'U', name: 'Sucumbíos' },
  { code: 'T', name: 'Tungurahua' },
  { code: 'Z', name: 'Zamora-Chinchipe' },
];

// Mexico States
export const MEXICO_STATES = [
  { code: 'AGU', name: 'Aguascalientes' },
  { code: 'BCN', name: 'Baja California' },
  { code: 'BCS', name: 'Baja California Sur' },
  { code: 'CAM', name: 'Campeche' },
  { code: 'CHP', name: 'Chiapas' },
  { code: 'CHH', name: 'Chihuahua' },
  { code: 'COA', name: 'Coahuila' },
  { code: 'COL', name: 'Colima' },
  { code: 'DUR', name: 'Durango' },
  { code: 'DIF', name: 'Federal District' },
  { code: 'GUA', name: 'Guanajuato' },
  { code: 'GRO', name: 'Guerrero' },
  { code: 'HID', name: 'Hidalgo' },
  { code: 'JAL', name: 'Jalisco' },
  { code: 'MEX', name: 'Mexico State' },
  { code: 'MIC', name: 'Michoacán' },
  { code: 'MOR', name: 'Morelos' },
  { code: 'NAY', name: 'Nayarit' },
  { code: 'NLE', name: 'Nuevo León' },
  { code: 'OAX', name: 'Oaxaca' },
  { code: 'PUE', name: 'Puebla' },
  { code: 'QUE', name: 'Querétaro' },
  { code: 'ROO', name: 'Quintana Roo' },
  { code: 'SLP', name: 'San Luis Potosí' },
  { code: 'SIN', name: 'Sinaloa' },
  { code: 'SON', name: 'Sonora' },
  { code: 'TAB', name: 'Tabasco' },
  { code: 'TAM', name: 'Tamaulipas' },
  { code: 'TLA', name: 'Tlaxcala' },
  { code: 'VER', name: 'Veracruz' },
  { code: 'YUC', name: 'Yucatán' },
  { code: 'ZAC', name: 'Zacatecas' },
];

// Chile Provinces
export const CHILE_STATES = [
  { code: 'AISÉN', name: 'Aisén' },
  { code: 'ANTOFAGASTA', name: 'Antofagasta' },
  { code: 'ANTÁRTICA CHILENA', name: 'Antártica Chilena' },
  { code: 'ARAUCO', name: 'Arauco' },
  { code: 'ARICA', name: 'Arica' },
  { code: 'BIOBÍO', name: 'Biobío' },
  { code: 'CACHAPOAL', name: 'Cachapoal' },
  { code: 'CAPITÁN PRAT', name: 'Capitán Prat' },
  { code: 'CARDENAL CARO', name: 'Cardenal Caro' },
  { code: 'CAUQUENES', name: 'Cauquenes' },
  { code: 'CAUTÍN', name: 'Cautín' },
  { code: 'CHACABUCO', name: 'Chacabuco' },
  { code: 'CHAÑARAL', name: 'Chañaral' },
  { code: 'CHILOÉ', name: 'Chiloé' },
  { code: 'CHOAPA', name: 'Choapa' },
  { code: 'COIHAIQUE', name: 'Coihaique' },
  { code: 'COLCHAGUA', name: 'Colchagua' },
  { code: 'CONCEPCIÓN', name: 'Concepción' },
  { code: 'COPIAPÓ', name: 'Copiapó' },
  { code: 'CORDILLERA', name: 'Cordillera' },
  { code: 'CURICÓ', name: 'Curicó' },
  { code: 'EL LOA', name: 'El Loa' },
  { code: 'ELQUI', name: 'Elqui' },
  { code: 'GENERAL CARRERA', name: 'General Carrera' },
  { code: 'HUASCO', name: 'Huasco' },
  { code: 'IQUIQUE', name: 'Iquique' },
  { code: 'ISLA DE PASCUA', name: 'Isla de Pascua' },
  { code: 'LIMARÍ', name: 'Limarí' },
  { code: 'LINARES', name: 'Linares' },
  { code: 'LLANQUIHUE', name: 'Llanquihue' },
  { code: 'LOS ANDES', name: 'Los Andes' },
  { code: 'MAGALLANES', name: 'Magallanes' },
  { code: 'MAIPO', name: 'Maipo' },
  { code: 'MALLECO', name: 'Malleco' },
  { code: 'MARGA MARGA', name: 'Marga Marga' },
  { code: 'MELIPILLA', name: 'Melipilla' },
  { code: 'OSORNO', name: 'Osorno' },
  { code: 'PALENA', name: 'Palena' },
  { code: 'PARINACOTA', name: 'Parinacota' },
  { code: 'PETORCA', name: 'Petorca' },
  { code: 'QUILLOTA', name: 'Quillota' },
  { code: 'RANCO', name: 'Ranco' },
  { code: 'SAN ANTONIO', name: 'San Antonio' },
  { code: 'SAN FELIPE DE ACONCAGUA', name: 'San Felipe de Aconcagua' },
  { code: 'SANTIAGO', name: 'Santiago' },
  { code: 'TALAGANTE', name: 'Talagante' },
  { code: 'TALCA', name: 'Talca' },
  { code: 'TAMARUGAL', name: 'Tamarugal' },
  { code: 'TIERRA DEL FUEGO', name: 'Tierra del Fuego' },
  { code: 'TOCOPILLA', name: 'Tocopilla' },
  { code: 'VALDIVIA', name: 'Valdivia' },
  { code: 'VALPARAÍSO', name: 'Valparaíso' },
  { code: 'ÑUBLE', name: 'Ñuble' },
  { code: 'ÚLTIMA ESPERANZA.', name: 'Última Esperanza.' },
];

// Japan Prefectures
export const JAPAN_STATES = [
  { code: '北海道', name: '北海道' },
  { code: '青森', name: '青森' },
  { code: '岩手', name: '岩手' },
  { code: '宮城', name: '宮城' },
  { code: '秋田', name: '秋田' },
  { code: '山形', name: '山形' },
  { code: '福島', name: '福島' },
  { code: '茨城', name: '茨城' },
  { code: '栃木', name: '栃木' },
  { code: '群馬', name: '群馬' },
  { code: '埼玉', name: '埼玉' },
  { code: '千葉', name: '千葉' },
  { code: '東京', name: '東京' },
  { code: '神奈川', name: '神奈川' },
  { code: '新潟', name: '新潟' },
  { code: '富山', name: '富山' },
  { code: '石川', name: '石川' },
  { code: '福井', name: '福井' },
  { code: '山梨', name: '山梨' },
  { code: '長野', name: '長野' },
  { code: '岐阜', name: '岐阜' },
  { code: '静岡', name: '静岡' },
  { code: '愛知', name: '愛知' },
  { code: '三重', name: '三重' },
  { code: '滋賀', name: '滋賀' },
  { code: '京都', name: '京都' },
  { code: '大阪', name: '大阪' },
  { code: '兵庫', name: '兵庫' },
  { code: '奈良', name: '奈良' },
  { code: '和歌山', name: '和歌山' },
  { code: '鳥取', name: '鳥取' },
  { code: '島根', name: '島根' },
  { code: '岡山', name: '岡山' },
  { code: '広島', name: '広島' },
  { code: '山口', name: '山口' },
  { code: '徳島', name: '徳島' },
  { code: '香川', name: '香川' },
  { code: '愛媛', name: '愛媛' },
  { code: '高知', name: '高知' },
  { code: '福岡', name: '福岡' },
  { code: '佐賀', name: '佐賀' },
  { code: '長崎', name: '長崎' },
  { code: '熊本', name: '熊本' },
  { code: '大分', name: '大分' },
  { code: '宮崎', name: '宮崎' },
  { code: '鹿児島', name: '鹿児島' },
  { code: '沖縄', name: '沖縄' },
];

const STATE_MAP: Record<string, typeof US_STATES> = {
  US: US_STATES,
  CA: CANADA_STATES,
  PR: PUERTO_RICO_STATES,
  EC: ECUADOR_STATES,
  MX: MEXICO_STATES,
  CL: CHILE_STATES,
  JP: JAPAN_STATES,
};

const ALL_STATES = Object.values(STATE_MAP).reduce(
  (acc, states) => acc.concat(states),
  [] as { code: string; name: string }[],
);

export const getStatesByCountry = (countryCode: string) => {
  const states = STATE_MAP[countryCode];

  if (states) {
    return states.map(({ code, name }) => ({
      id: code,
      label: name,
      value: code,
    }));
  }

  return [];
};

export const isStateValidForCountry = (
  stateCode: string | undefined,
  countryCode: string | undefined,
) => {
  if (!stateCode || !countryCode) return false;

  return getStatesByCountry(countryCode).some(
    ({ value }) => value === stateCode,
  );
};

export const getStateDisplayName = (stateCode?: string) => {
  if (!stateCode) return undefined;

  return ALL_STATES.find(({ code }) => code === stateCode)?.name;
};
